angular.module('eStories.account.model', [])

    .service('AccountModel', [
        'WS',
        '$rootScope',
        'ModalsModel',
        '$state',
        '$location',
        '$filter',
        '$interpolate',
        'BillingModel',
        'PromoModel',
        'LL',
        '$cookies',
        'CatalogModel',
        'GiftModel',
        '$timeout',

        function (WS, $rootScope, ModalsModel, $state, $location, $filter, $interpolate, BillingModel, PromoModel, LL, $cookies, CatalogModel, GiftModel, $timeout) {
            this.userDetails = null;
            this.savedPaymentDetails = null;
            this.subscriptionDetails = null;

            this.trialType = 'basic';
            this.isFreemium = false;

            this.cancelReasonDescription = null;

            this.requestPrivacyDataDump = (toEmail) => {
                return WS.callServer('account/requestPrivacyDataDump', {toEmail: toEmail});
            };

            this.requestAccountDeletion = () => WS.callServer('account/requestAccountDeletion', {});

            this.searchUtmSourceParameter = () => {
                var utmSource = $location.search()['utm_source'];
                if (utmSource == null) {
                    return null;
                }
                return utmSource;
            };

            this.setCancelReasonDescription = (reasonDescription) => {
                this.cancelReasonDescription = reasonDescription;
            };

            this.getUserEmailPreferences = (snid, email) => {
                return WS.callServer('account/getUserEmailPreferences', {snid: snid, email: email});
            };

            this.clearCancelSubscriptionLater = (subscriptionId) => {
                var clearCancelSubsObj = {
                    subscriptionId: subscriptionId
                };
                return WS.callServer('subscription/clearCancelSubscriptionLater', clearCancelSubsObj)
            };

            this.cancelSubscriptionLater = (subscriptionId, reason, reasonDescription) => {
                var cancelSubsObj = {
                    subscriptionId: subscriptionId,
                    reason: reason ? reason : 'VOLUNTARY_USER_CANCEL',
                    reasonDescription: reasonDescription
                };
                return WS.callServer('subscription/cancelSubscriptionLater', cancelSubsObj)
            };

            this.updateUserEmailPreferences = (updateEmailDetailsObj) => {
                return WS.callServer('account/updateUserEmailPreferences', updateEmailDetailsObj);
            };

            this.setPendingAudiobookPurchase = (audiobook, purchaseType) => {
                this.pendingAudiobookPurchase = {audiobook: audiobook, purchaseType: purchaseType};
            };

            this.resetPendingAudiobookPurchase = () => {
                this.pendingAudiobookPurchase = null;
            };

            this.showPurchaseAudiobookModal = (audiobook, purchaseType) => {
                this.setPendingAudiobookPurchase(audiobook, purchaseType);
                this.reportLlSelectEvent(purchaseType);
                ModalsModel.open("/purchase/confirmPurchase.tmpl.html", "ConfirmPurchaseCtrl", "confirmPurchaseCtrl", "purchaseAudiobookModal");
            };

            this.showPostBoosterPurchaseModal = () => {
                ModalsModel.open("/purchase/postBoosterPurchaseModal.tmpl.html", "ConfirmPurchaseCtrl", "confirmPurchaseCtrl", null);
            };

            this.reportLlSelectEvent = (purchaseType) => {
                switch (purchaseType) {
                    case 'RETAIL':
                        var selectRetailPurchaseObj = {
                            member: this.isUserLoggedIn ? 'yes' : 'no'
                        };
                        LL.tagEvent('Selected Retail Purchase', selectRetailPurchaseObj);
                        break;
                    default:
                        break;
                }
            };

            this.openGiftAcceptedModal = () => {
                GiftModel.removeGiftToken();
                $state.go('home');
                ModalsModel.open("/purchase/gift/redeem/acceptGiftModal.tmpl.html", "RedeemGiftCtrl", "redeemGiftCtrl");
            };

            this.openGiftRedemptionModal = () => {
                ModalsModel.openGiftRedeemModal("/purchase/gift/redeem/redeemGiftModal.tmpl.html", "RedeemGiftCtrl", "redeemGiftCtrl", null);
            };

            this.openIneligibleGiftModal = () => {
                ModalsModel.open("/purchase/gift/ineligibleGiftModal.tmpl.html", "IneligibleGiftCtrl", "ineligibleGiftCtrl");
            };

            this.openPurchaseGiftModal = () => {
                ModalsModel.open("/purchase/gift/giftRegistrationModal.tmpl.html", "GiftRegistrationCtrl", "giftRegistrationCtrl");
            };

            this.showGiftTermsModal = () => {
                ModalsModel.open("/terms/giftTermsModal.tmpl.html", "GiftTermsCtrl", "giftTermsCtrl");
            };

            this.openGiftRegistration = () => {
                this.showUpdatePaymentDetailsModal();
                return;

                ModalsModel.open("/purchase/gift/purchaseGiftModal.tmpl.html", "GiftPurchaseCtrl", "giftPurchaseCtrl");
            };

            this.showUpdatePaymentDetailsModal = (updateDetails) => {
                this.updateDetails = !!updateDetails;
                ModalsModel.open("/purchase/updatePaymentDetails.tmpl.html", "UpdatePaymentDetailsCtrl", "updatePaymentDetailsCtrl");
            };

            this.showPostGiftPurchaseModal = () => {
                ModalsModel.open("/purchase/gift/giftPurchaseSuccess.tmpl.html", "GiftPurchaseCtrl", "giftPurchaseCtrl");
            };

            this.showConfirmGiftMessageModal = () => {
                ModalsModel.open("/purchase/gift/confirmGiftMessage.tmpl.html", "PreviewGiftCtrl", "previewGiftCtrl");
            };

            this.showUniversalUpdatePaymentDetailsModal = (updateDetails) => {
                this.updateDetails = !!updateDetails;
                ModalsModel.open("/purchase/updateUniversalPaymentDetails.tmpl.html", "UpdatePaymentDetailsCtrl", "updatePaymentDetailsCtrl");
            };

            this.goToCommunicationSettingsPage = () => {
                $location.path("/communicationSettings");
            };

            this.getSubscriptionDetails = () => {
                return WS.callServer('subscription/getSubscriptionDetails', {});
            };

            this.getCreditDetails = () => {
                return WS.callServer('credit/getCreditDetails', {});
            };

            this.getLocation = () => {
                return WS.callServer('account/getLocation', {});
            };

            this.getSavedPaymentDetails = () => {
                return WS.callServer('billing/getSavedPaymentDetails', {});
            };

            this.getUserDetails = () => {
                return WS.callServer('account/getUserDetails', {});
            };

            this.signOut = async () => {
                const response = await WS.callServer('account/signOut', {});
                if (response != null && response.responseStatus === 'SUCCESS') {
                    this.resetPlanPurchaseProperties();
                    $rootScope.$broadcast('successfulSignOut');
                    CatalogModel.landingSectionsMap = null;
                }
            };

            /*TODO: Revisit this idea*/
            this.handleUserDetailsResponse = (response) => {
                if (response != null && response.responseStatus === 'SUCCESS') {
                    this.isUserLoggedIn = true;
                }
            };

            this.extraCreditSale = async () => {
                if (this.areExtraBoostersAllowed()) {
                    const response =
                        await PromoModel.getPromoDetails('EC25ZEA6E2156F562C445E049C002575',
                            null,
                            true,
                            null);

                    if (response && response.responseStatus === "SUCCESS" && !PromoModel.promoIneligibile) {
                        PromoModel.promoPackage = response.promotion;
                        PromoModel.promoCodeHash = 'EC25ZEA6E2156F562C445E049C002575';
                        $rootScope.$broadcast('promoDetailsLoaded', response);
                    }
                }
            };

            $rootScope.$on('signUpComplete', (event, obj) => {
                this.accountSetupObj = obj;
            });

            this.getAccountSetupObj = () => {
                return this.accountSetupObj;
            };

            this.resetAccountSetup = () => {
                this.accountSetupObj = null;
            };

            this.refreshUserDetails = async (successCallback, errorCallback) => {
                const response = await this.getUserDetails();
                if (response != null && response.responseStatus === "SUCCESS") {
                    this.userDetails = response;
                    if (response.snid != null) {
                        LL.setCustomerData(response.snid, response.email, response.fullName);
                        LL.setCustomDimension(0, response.memberType);
                        LL.setCustomDimension(1, response.userType);

                        /*Localytics Tag Account Setup*/
                        if (this.getAccountSetupObj()) {
                            var accountSetupObj = this.getAccountSetupObj();
                            $timeout(() => {
                                LL.tagEvent('Account Set Up', accountSetupObj);
                                this.resetAccountSetup();
                            }, 500);
                        }

                    }
                    if (successCallback) {
                        successCallback(response);
                    }
                    //Check if cookie for attempted url is not null, if not, redirect to that URL
                    if ($cookies.get('ATTEMPTED_URL')) {
                        $location.path($cookies.get('ATTEMPTED_URL'));
                        $cookies.remove('ATTEMPTED_URL');
                    }
                } else if (errorCallback) {
                    if (this.locationPathOnlyForLoggedIn($location.path())) {
                        $timeout(() => {
                            $cookies.put('ATTEMPTED_URL', $location.path());
                            $location.path('/');
                            ModalsModel.open('/registration/signInModal.tmpl.html', 'RegistrationCtrl', 'regCtrl');
                        }, 5000);
                    }
                    errorCallback(response);
                }
            };

            this.getGiftDetails = () => {
                GiftModel.getGiftDetails(GiftModel.giftToken, (response) => {
                    if (response != null && response.responseStatus === 'SUCCESS') {
                        GiftModel.assignRedeemCreditsDetails(response);
                    }
                }, () => {
                    this.openIneligibleGiftModal();
                });
            };

            this.acceptGift = async () => {
                try {
                    const response = await GiftModel.redeemGift(GiftModel.giftToken);
                    this.refreshSubscriptionDetails.then(() => {
                        $location.path('/');
                    });
                    if (response.responseStatus === 'SUCCESS') {
                        this.openGiftAcceptedModal();
                    } else {
                        this.openIneligibleGiftModal();
                    }
                } catch (e) {
                    this.openIneligibleGiftModal();
                }
            };

            this.reportSubscriptionDetailsLoaded = () => {
                setTimeout(() => {
                    this.subscriptionDetailsLoaded = true;
                    safeApply($rootScope);
                }, 1000);
            };

            this.getProductByGroup = (purchaseType, audiobook) => {
                if (audiobook == null) {
                    return null;
                }

                for (var i = 0; i < audiobook.productList.length; i++) {
                    var product = audiobook.productList[i];
                    if (product.purchaseType === purchaseType) {
                        return product;
                    }
                }
            };

            this.getMyPrice = (audiobook, includeCurrency, getMemberPrice) => {
                if (getMemberPrice) {
                    //    check if is trialer, then change getMemberPrice to false
                    this.isTrialMember() ? getMemberPrice = false : getMemberPrice
                }
                if (includeCurrency == null) {
                    includeCurrency = true;
                }
                var productByGroup = this.getProductByGroup('RETAIL', audiobook);
                if (productByGroup == null) {
                    return null;
                }
                var nonSalePrice = includeCurrency ? $filter("currencyToSymbol")(productByGroup.currency) : "";
                if (getMemberPrice) {
                    nonSalePrice += productByGroup.memberPrice;
                } else {
                    nonSalePrice += productByGroup.nonMemberPrice;
                }

                var salePrice = includeCurrency ? $filter("currencyToSymbol")(productByGroup.currency) : "";

                if (getMemberPrice) {
                    salePrice += productByGroup.memberPromoPrice;
                } else {
                    salePrice += productByGroup.nonMemberPromoPrice;
                }

                return (salePrice.indexOf(null) > -1 ? nonSalePrice : "<span class='strikeThrough'>" + nonSalePrice + "</span>") + " " + (salePrice.indexOf(null) > -1 ? "" : "<span class='bold'>" + salePrice + "</span>");

            };

            this.getPrice = (audiobook, includeCurrency) => {
                var getMemberPrice = this.isPaidMember() || this.isTrialMember();
                return this.getMyPrice(audiobook, includeCurrency, getMemberPrice);
            };

            this.getAudiobookPrice = (audiobook, includeCurrency, getMemberPrice) => {
                if (includeCurrency == null) {
                    includeCurrency = true;
                }
                var productByGroup = this.getProductByGroup('RETAIL', audiobook);
                if (productByGroup == null) {
                    return null;
                }
                var result = includeCurrency ? $filter("currencyToSymbol")(productByGroup.currency) : "";
                if (getMemberPrice) {
                    result += productByGroup.memberPrice;
                } else {
                    result += productByGroup.nonMemberPrice;
                }

                return result;
            };

            this.getMyAudiobookPrice = (audiobook, includeCurrency) => {
                var getMemberPrice = this.isPaidMember();
                return this.getAudiobookPrice(audiobook, includeCurrency, getMemberPrice);
            };

            this.signUpOrConfirmTrial = () => {
                //this BillingModel.isPlanPurchase is here so I can tell the  if a user is purchasing
                //a trial or an alc book. Is important for the updatePaymentDetails.tmpl.html
                this.resetPendingAudiobookPurchase();
                BillingModel.isPlanPurchase = true;
                if (PromoModel.hasPlanPromo()) {
                    this.setChosenPlan(PromoModel.promoPackage.billingPlan);
                    this.setPendingPlanPurchaseType("PROMO");
                } else if ($location.path().indexOf('free_books') > -1) {
                    this.setPendingPlanPurchaseType("FREEMIUM");
                    LL.tagEvent('Selected Freemium');
                } else if ($state.current.name === 'eStories.navbars.freemium' ||
                    $state.current.name === 'eStories.navbars.redeemGift') {
                    this.setPendingPlanPurchaseType("FREEMIUM");
                    LL.tagEvent('Selected Freemium');
                } else if (($state.current.name === 'eStories.navbars.audiobook' || $state.current.name === 'eStories.navbars.audiobookFull') && this.isFreemium) {
                    this.setPendingPlanPurchaseType("FREEMIUM");
                    LL.tagEvent('Select Freemium Book Detail');
                } else {
                    this.setPendingPlanPurchaseType("BASIC_TRIAL");
                    llObj = {
                        "OfferType": this.pendingPlanPurchaseType,
                        "Source": (this.searchUtmSourceParameter() != null) ? this.searchUtmSourceParameter() : null
                    };
                    LL.tagEvent('Selected Trial Promo', llObj);
                }
                if (this.isUserLoggedIn) {
                    this.showUpdatePaymentDetailsModal();
                } else {
                    this.showSignUp();
                }
            };

            this.signInOrConfirmTrial = () => {
                //this BillingModel.isPlanPurchase is here so I can tell the  if a user is purchasing
                //a trial or an alc book. Is important for the updatePaymentDetails.tmpl.html
                BillingModel.isPlanPurchase = true;
                if (PromoModel.hasPlanPromo()) {
                    this.setPendingPlanPurchaseType("PROMO");
                } else if ($state.current.name === 'eStories.navbars.redeemGift') {
                    this.setPendingPlanPurchaseType("FREEMIUM");
                    LL.tagEvent('Selected Freemium');
                } else {
                    this.setPendingPlanPurchaseType("BASIC_TRIAL");
                    llObj = {
                        "OfferType": this.pendingPlanPurchaseType,
                        "Source": (this.searchUtmSourceParameter() != null) ? this.searchUtmSourceParameter() : null
                    };
                    LL.tagEvent('Selected Trial Promo', llObj);
                }
                if (this.isUserLoggedIn) {
                    this.showUpdatePaymentDetailsModal();
                } else {
                    this.showSignIn();
                }
            };

//          when user offered a promo deal
            this.signUpOrConfirmPromo = () => {
                //this BillingModel.isPlanPurchase is here so I can tell the  if a user is purchasing
                //a trial or an alc book. Is important for the updatePaymentDetails.tmpl.html
                BillingModel.isPlanPurchase = true;
                if (this.isUserLoggedIn) {
                    this.showUpdatePaymentDetailsModal();
                } else {
                    this.showSignUp();
                }
            };


            this.refreshSubscriptionDetails = async (callbackFunc, getPromoDetailsCallbackFunc) => {
                const response = await this.getSubscriptionDetails();
                this.reportSubscriptionDetailsLoaded();

                const creditDetailsResponse = await this.getCreditDetails();
                if (creditDetailsResponse != null && creditDetailsResponse.responseStatus === "SUCCESS") {
                    this.giftCredit = creditDetailsResponse.giftDetails;
                }

                if (response != null) {
                    if (response.availableCredit > 0) {
                        if (this.subscriptionDetails == null) {
                            this.subscriptionDetails = {};
                        }
                        this.subscriptionDetails.availableCredit = response.availableCredit;
                    }

                    if (response.responseStatus === "SUCCESS") {
                        this.subscriptionDetails = response;
                        $rootScope.$broadcast('refreshPromoBar');
                        if (!PromoModel.hasPlanPromo()) {
                            this.extraCreditSale().then();
                        }
                        if (this.subscriptionDetails.subscription.promotionCode) {
                            try {
                                const response = await PromoModel.getPromoDetails(
                                    this.subscriptionDetails.subscription.promotionCode,
                                    this.subscriptionDetails.subscription.plan.planPricingId,
                                    false,
                                    null);

                                this.subscriptionDetails.promoPackage = response.promotion;
                                const interpolationContext = {
                                    currency: this.subscriptionDetails.subscription.plan.currency,
                                    currencySymbol: $filter("currencyToSymbol")(this.subscriptionDetails.subscription.plan.currency),
                                    grossPrice: this.subscriptionDetails.subscription.plan.price,
                                    discountedPrice: this.calculateDiscountedPrice(this.subscriptionDetails.subscription.plan.price, this.subscriptionDetails.promoPackage.discountAmount, this.subscriptionDetails.promoPackage.addOnAmount),
                                    conversionPlanPrice: this.subscriptionDetails.promoPackage.conversionBillingPlan != null ? this.subscriptionDetails.promoPackage.conversionBillingPlan.price : this.subscriptionDetails.subscription.plan.price
                                };

                                if (this.subscriptionDetails.promoPackage.callToActionCopy) {
                                    this.subscriptionDetails.promoPackage.callToActionCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.callToActionCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.checkoutCopy) {
                                    this.subscriptionDetails.promoPackage.checkoutCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.checkoutCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.checkoutDescriptionCopy) {
                                    this.subscriptionDetails.promoPackage.checkoutDescriptionCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.checkoutDescriptionCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.accountPageCopy) {
                                    this.subscriptionDetails.promoPackage.accountPageCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.accountPageCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.accountPageDescriptionCopy) {
                                    this.subscriptionDetails.promoPackage.accountPageDescriptionCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.accountPageDescriptionCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.featureHeadlineCopy) {
                                    this.subscriptionDetails.promoPackage.featureHeadlineCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.featureHeadlineCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.featureSubHeadlineCopy) {
                                    this.subscriptionDetails.promoPackage.featureSubHeadlineCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.featureSubHeadlineCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.featureDescriptionCopy) {
                                    this.subscriptionDetails.promoPackage.featureDescriptionCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.featureDescriptionCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.landingHeadlineCopy) {
                                    this.subscriptionDetails.promoPackage.landingHeadlineCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.landingHeadlineCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.landingListCopy) {
                                    this.subscriptionDetails.promoPackage.landingListCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.landingListCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.termsCopy) {
                                    this.subscriptionDetails.promoPackage.termsCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.termsCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.plansPagePriceCopy) {
                                    this.subscriptionDetails.promoPackage.plansPagePriceCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.plansPagePriceCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.plansPageDescriptionCopy) {
                                    this.subscriptionDetails.promoPackage.plansPageDescriptionCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.plansPageDescriptionCopy, false, null, true)(interpolationContext);
                                }
                                if (this.subscriptionDetails.promoPackage.plansPageSaleCopy) {
                                    this.subscriptionDetails.promoPackage.plansPageSaleCopy =
                                        $interpolate(this.subscriptionDetails.promoPackage.plansPageSaleCopy, false, null, true)(interpolationContext);
                                }
                                if (getPromoDetailsCallbackFunc) getPromoDetailsCallbackFunc(response);
                            } catch (e) {
                                return e;
                            }
                        }
                    }
                }
                if ($state.current.name === 'eStories.navbars.groupon2mo2cdt' ||
                    $state.current.name === 'eStories.navbars.specialTrial') {
                    $rootScope.$broadcast('subscriptionDetailsLoaded');
                }
                if (callbackFunc) callbackFunc(response);
            };


            this.refreshSavedPaymentDetails = async (successCallback, errorCallback) => {
                const response = await this.getSavedPaymentDetails();
                if (response != null && response.responseStatus === "SUCCESS") {
                    if (response.paymentMethod) {
                        this.savedPaymentDetails = response;
                    }
                    if (successCallback) {
                        successCallback(response);
                    }
                } else if (errorCallback) {
                    errorCallback(response);
                }
            };

            this.locationPathOnlyForLoggedIn = (locationPath) => {
                if (locationPath === '/communicationSettings' && Object.keys($location.search()).length > 0) {
                    return false;
                }
                return locationPath === '/account' || locationPath === '/library' ||
                    locationPath === '/cancel' || locationPath === '/account/cancel' ||
                    locationPath === '/wishlist' || locationPath === '/account/overview' ||
                    locationPath === 'account/cancel' || locationPath === '/communicationSettings' ||
                    locationPath === '/account/upload' || locationPath === '/account/extraCredits' ||
                    locationPath === '/upload' || locationPath.startsWith('/account/updatePlan');
            };

            this.resetPlanPurchaseProperties = () => {
                this.setPendingPlanPurchaseType(null);
                this.setChosenPlan(null);
                this.chosenVanityPromoPlan = null;
                this.setPendingPostChoosePlanAction(null);
                this.pendingAudiobookPurchase = null;
            };

            this.setPendingPlanPurchaseType = (pendingPlanPurchaseType) => {
                if (pendingPlanPurchaseType === undefined) {
                    return;
                }
                this.pendingPlanPurchaseType = pendingPlanPurchaseType;
            };

            this.setPendingPostChoosePlanAction = (pendingPostChoosePlanAction) => {
                if (pendingPostChoosePlanAction === undefined) {
                    return;
                }
                this.pendingPostChoosePlanAction = pendingPostChoosePlanAction;
            };

            this.setChosenPlan = (plan) => {
                if (plan === undefined) {
                    return;
                }
                this.chosenPlan = plan;
            };

            this.setInterpolation = (response) => {
                if (response) {
                    PromoModel.promoPackage = response.promotion;
                }

                var interpolationContext = {
                    currency: this.chosenPlan.currency,
                    currencySymbol: $filter("currencyToSymbol")(this.chosenPlan.currency),
                    grossPrice: this.chosenPlan.price,
                    discountedPrice: this.calculateDiscountedPrice(this.chosenPlan.price, PromoModel.promoPackage.discountAmount, PromoModel.promoPackage.addOnAmount),
                    conversionPlanPrice: this.getChosenVanityPromoPlan().price,
                    conversionPlanBillingCycleUnitType: this.getChosenVanityPromoPlan().billingCycleUnitType === "MONTHLY" ? "month" : "year"
                };

                if (PromoModel.promoPackage.callToActionCopy) {
                    PromoModel.promoPackage.callToActionCopy = $interpolate(PromoModel.promoPackage.callToActionCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.checkoutCopy) {
                    PromoModel.promoPackage.checkoutCopy = $interpolate(PromoModel.promoPackage.checkoutCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.checkoutDescriptionCopy) {
                    PromoModel.promoPackage.checkoutDescriptionCopy = $interpolate(PromoModel.promoPackage.checkoutDescriptionCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.accountPageCopy) {
                    PromoModel.promoPackage.accountPageCopy = $interpolate(PromoModel.promoPackage.accountPageCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.accountPageDescriptionCopy) {
                    PromoModel.promoPackage.accountPageDescriptionCopy = $interpolate(PromoModel.promoPackage.accountPageDescriptionCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.featureHeadlineCopy) {
                    PromoModel.promoPackage.featureHeadlineCopy = $interpolate(PromoModel.promoPackage.featureHeadlineCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.featureSubHeadlineCopy) {
                    PromoModel.promoPackage.featureSubHeadlineCopy = $interpolate(PromoModel.promoPackage.featureSubHeadlineCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.featureDescriptionCopy) {
                    PromoModel.promoPackage.featureDescriptionCopy = $interpolate(PromoModel.promoPackage.featureDescriptionCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.landingHeadlineCopy) {
                    PromoModel.promoPackage.landingHeadlineCopy = $interpolate(PromoModel.promoPackage.landingHeadlineCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.landingListCopy) {
                    PromoModel.promoPackage.landingListCopy = $interpolate(PromoModel.promoPackage.landingListCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.termsCopy) {
                    PromoModel.promoPackage.termsCopy = $interpolate(PromoModel.promoPackage.termsCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.plansPagePriceCopy) {
                    PromoModel.promoPackage.plansPagePriceCopy = $interpolate(PromoModel.promoPackage.plansPagePriceCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.plansPageDescriptionCopy) {
                    PromoModel.promoPackage.plansPageDescriptionCopy = $interpolate(PromoModel.promoPackage.plansPageDescriptionCopy, false, null, true)(interpolationContext);
                }
                if (PromoModel.promoPackage.plansPageSaleCopy) {
                    PromoModel.promoPackage.plansPageSaleCopy = $interpolate(PromoModel.promoPackage.plansPageSaleCopy, false, null, true)(interpolationContext);
                }

            };

            this.setChosenPromoPlan = (response) => {
                if (response === undefined || response.promotion === undefined) {
                    return;
                }
                this.chosenPlan = response.promotion.billingPlan;
                this.setChosenVanityPromoPlan(response.promotion.conversionBillingPlan == null ?
                    response.promotion.billingPlan : response.promotion.conversionBillingPlan);
                this.setInterpolation(response);
            };

            this.showChoosePlanModal = () => {
                ModalsModel.open("/purchase/choosePlan.tmpl.html", "ChoosePlanCtrl", "choosePlanCtrl");
            };

            this.showSignUp = () => {
                ModalsModel.open('/registration/signUpModal.tmpl.html', 'RegistrationCtrl', 'regCtrl');
            };

            this.showSignIn = () => {
                ModalsModel.open('/registration/signInModal.tmpl.html', 'RegistrationCtrl', 'regCtrl');
            };

            this.showEligibilityModal = () => {
                ModalsModel.open('/home/promo/promoEligibilityModal.tmpl.html', 'PromoEligibilityCtrl', 'promoEligibilityCtrl')
            };

            this.showPromoTermsModal = () => {
                ModalsModel.open("/terms/promoTerms.tmpl.html", "PromoTermsCtrl", "promoTermsCtrl");
            };

            this.getNextCreditRenewalDate = () => {
                if (!this.hasSubscription()) {
                    return null;
                }
                var nextCreditRenewalDate = this.subscriptionDetails.subscription.nextCreditRenewalDate;
                return this.convertDateSecondsToString(nextCreditRenewalDate);
            };

            this.shouldShowHoldMembershipOption = () => {
                if (!this.subscriptionDetails) {
                    return;
                }
                if (this.hasPromoPlan()) {
                    return;
                }
                return !this.isTrialMember() &&
                    this.subscriptionDetails.subscription &&
                    !this.subscriptionDetails.subscription.freezeDate &&
                    this.isPaidMember();
            };

            this.getNextBillingAttemptDate = (shortMonth) => {
                if (!this.hasSubscription()) {
                    return null;
                }
                var nextBillingAttemptDate = this.subscriptionDetails.subscription.nextBillingAttemptDate;
                var date = new Date(nextBillingAttemptDate);
                var day = $filter('date')(date, 'd');
                var suffixes = ["th", "st", "nd", "rd"];
                var relevantDigits = (day < 30) ? day % 20 : day % 30;
                var suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
                return $filter('date')(date, (shortMonth ? "MMM" : "LLLL") + " d'" + suffix + "', yyyy")
            };

            this.getUpcomingCancellationDate = () => {
                if (!this.hasSubscription()) {
                    return null;
                }
                var upcomingCancellationDate = this.subscriptionDetails.subscription.upcomingCancellationDate;
                var date = new Date(upcomingCancellationDate);
                var day = $filter('date')(date, 'd');
                var suffixes = ["th", "st", "nd", "rd"];
                var relevantDigits = (day < 30) ? day % 20 : day % 30;
                var suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
                return $filter('date')(date, "LLLL d'" + suffix + "', yyyy")
            };

            this.getNextCreditRenewalDate = () => {
                if (!this.hasSubscription()) {
                    return null;
                }
                var nextCreditRenewalDate = this.subscriptionDetails.subscription.nextCreditRenewalDate;
                var date = new Date(nextCreditRenewalDate);
                var day = $filter('date')(date, 'd');
                var suffixes = ["th", "st", "nd", "rd"];
                var relevantDigits = (day < 30) ? day % 20 : day % 30;
                var suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
                return $filter('date')(date, "LLLL d'" + suffix + "', yyyy")

            };

            this.convertDateSecondsToString = (dateInSeconds) => {
                var date = new Date(dateInSeconds);
                var day = $filter('date')(date, 'd');
                var suffixes = ["th", "st", "nd", "rd"];
                var relevantDigits = (day < 30) ? day % 20 : day % 30;
                var suffix = (relevantDigits <= 3) ? suffixes[relevantDigits] : suffixes[0];
                return $filter('date')(date, "LLLL d'" + suffix + "', yyyy")
            };

            this.getConversionPlan = () => {
                if (!this.hasSubscription()) {
                    return null;
                }
                return this.subscriptionDetails.subscription.conversionPlan;
            };

            this.getPlan = () => {
                if (!this.hasSubscription()) {
                    return null;
                }
                return this.subscriptionDetails.subscription.plan;
            };

            this.getPlanType = (plan) => {
                if (plan.planId === 333001200) {
                    return '2 Months';
                } else if (plan.family) {
                    if (plan.family === "WINBACK") {
                        return "Promo";
                    } else {
                        return plan.family;
                    }
                }
            };

            this.shouldShowCreditCount = () => {
                return this.subscriptionDetails != null
            };

            this.shouldShowGiftCreditCount = () => {
                return this.giftCredit != null && this.giftCredit.availableCredit > 0;
            };

            this.getSubscriptionExplanation = (subscription) => {
                if (subscription == null) {
                    return;
                }
                var billingCycleString;
                if (subscription.billingCycleUnitType === "MONTHLY") {
                    if (subscription.billingCycleUnitAmount === 1) {
                        billingCycleString = 'monthly';
                    } else {
                        billingCycleString = 'every ' + subscription.billingCycleUnitAmount + ' months';
                    }
                } else if (subscription.billingCycleUnitType === "QUARTERLY") {
                    billingCycleString = 'every ' + subscription.billingCycleUnitAmount * 3 + ' months';
                } else if (subscription.billingCycleUnitType === "YEARLY") {
                    if (subscription.billingCycleUnitAmount === 1) {
                        billingCycleString = 'annually';
                    } else {
                        billingCycleString = 'every ' + subscription.billingCycleUnitAmount + ' years';
                    }
                }
                return 'membership renews ' + billingCycleString;
            };

            this.getPlanFamily = () => {
                if (!this.subscriptionDetails) {
                    return;
                }
                return capitalizeFirstLetter(this.subscriptionDetails.subscription.plan.family.toLowerCase());
            };

            this.getSubscriptionName = (plan) => {
                if (plan == null) {
                    return;
                }
                return plan.packageList[0].name;
            };

            this.isAnnualSubscription = () => {
                return this.subscriptionDetails.subscription.plan.family === 'ANNUAL';
            };

            this.getCreditString = () => {
                return this.subscriptionDetails.subscription.plan.packageList[0].credits > 1 ? 'credits' : 'credit';
            };

            this.getSubscriptionCreditsFrequency = (subscription, trial, showFreq) => {
                if (subscription == null) {
                    return;
                }
                var creditsPerCycle = subscription.plan.packageList[0].credits;
                var freqString = '';
                var creditString = creditsPerCycle > 1 ? 'credits' : 'credit';
                if (trial) {
                    creditString = 'credit trial';
                } else if (showFreq) {
                    if (subscription.creditCycleUnitType === "MONTHLY") {
                        if (subscription.creditCycleUnitAmount === 1) {
                            freqString = ' a month';
                        } else {
                            freqString = ' every ' + subscription.creditCycleUnitAmount + ' months';
                        }
                    } else if (subscription.creditCycleUnitType === "YEARLY") {
                        if (subscription.creditCycleUnitAmount === 1) {
                            freqString = ' a year';
                        } else {
                            freqString = ' every ' + subscription.creditCycleUnitAmount + ' years';
                        }
                    } else if (subscription.creditCycleUnitType === "QUARTERLY") {
                        freqString = ' every ' + subscription.creditCycleUnitAmount * 3 + ' months';
                    }
                }

                return creditsPerCycle + ' ' + creditString + freqString;
            };

            this.getPaymentMethod = () => {
                if (this.savedPaymentDetails == null) {
                    return;
                }
                return this.savedPaymentDetails.paymentMethod;
            };

            this.isMigratedSubscription = () => {
                if (!this.hasSubscription()) {
                    return false;
                }

                return this.subscriptionDetails.subscription.migrated;
            };

            this.getCurrentPlanPrice = (withCreditCycle) => {
                if (!this.hasSubscription()) {
                    return;
                }
                var creditCycle = this.subscriptionDetails.subscription.creditCycleUnitType;
                if (withCreditCycle) {
                    var frequency = creditCycle === 'MONTHLY' ? '/month' : '/year'
                } else {
                    frequency = '';
                }
                return $filter('currencyToSymbol')(this.subscriptionDetails.subscription.plan.currency) +
                    this.subscriptionDetails.subscription.plan.price + frequency;
            };

            this.calculateDiscountedPrice = (basePrice, discountAmount, addOnAmount) => {
                return (Math.floor(basePrice ? basePrice * 100 : 0) -
                    Math.floor(discountAmount ? discountAmount * 100 : 0) +
                    Math.floor(addOnAmount ? addOnAmount * 100 : 0)) / 100;
            };

            this.isUserDelinquent = () => {
                if (!this.hasSubscription()) {
                    return;
                }
                return this.subscriptionDetails.subscription.status === 'DELINQUENT';
            };


            this.isSubscriptionValid = () => {
                return this.isMember();
            };

            this.isSubscriptionValidAndNotSetToCancel = () => {
                return this.isSubscriptionValid() && !this.subscriptionDetails.subscription.upcomingCancellationDate;
            };

            this.setChosenVanityPromoPlan = (plan) => {
                this.chosenVanityPromoPlan = plan;
            };

            this.getChosenVanityPromoPlan = () => {
                if (this.chosenVanityPromoPlan !== null) {
                    return this.chosenVanityPromoPlan;
                } else {
                    return this.chosenPlan;
                }
            };

            this.isSubscriptionFrozen = () => {
                if (!this.hasSubscription()) {
                    return;
                }
                return this.subscriptionDetails.status === 'FROZEN';
            };

            this.isMember = () => {
                return this.hasSubscription() &&
                    this.subscriptionDetails.status !== 'INACTIVE';
            };

            this.hasAvailableCredit = () => {
                if (this.subscriptionDetails == null) {
                    return false;
                }
                return this.subscriptionDetails.availableCredit > 0;
            };

            this.hasSubscription = () => {
                return this.subscriptionDetails != null && this.subscriptionDetails.subscription != null;
            };

            this.hasSubscriptionOrCredits = () => {
                return this.hasSubscription() || this.hasAvailableCredit();
            };

            this.hasAvailableGiftCredit = () => {
                return this.giftCredit ? this.giftCredit.availableCredit > 0 : null;
            };

            this.areExtraBoostersAllowed = () => {
                return this.isMember() && !this.subscriptionDetails.subscription.trial;
            };

            this.isPaidMember = () => {
                return this.isMember() && !this.subscriptionDetails.subscription.trial;
            };

            this.isTrialMember = () => {
                return this.isMember() && this.subscriptionDetails.subscription.trial;
            };

            this.getBoosterButtonText = () => {
                return PromoModel.hasCreditPromo() ? PromoModel.promoPackage.featureHeadlineCopy : "Buy an Extra Credit Pack now";
            };

            this.hasPromoPlan = () => {
                return this.isMember() && this.subscriptionDetails.promoPackage != null;
            };

            this.hasDiscountedPrice = () => {
                if (!PromoModel.hasPlanPromo() && !PromoModel.hasCreditPromo()) {
                    return false;
                }
                return PromoModel.promoPackage.discountAmount - PromoModel.promoPackage.addOnAmount > 0;
            };

            this.activePlanHasDiscountedPrice = () => {
                if (!this.hasPromoPlan()) {
                    return false;
                }
                return this.subscriptionDetails.promoPackage.discountAmount - this.subscriptionDetails.promoPackage.addOnAmount > 0;
            };

            this.isEligibleForTrial = () => {
                return this.userDetails == null || this.userDetails.eligibleForTrial;
            };

            this.canBuyAudiobookWithCredit = (audiobook) => {
                return this.getProductByGroup('CREDIT', audiobook) != null
            };

            $rootScope.$on('updateSubscriptionDetails', (subscriptionDetails) => {
                this.subscriptionDetails = subscriptionDetails;
            });

            $rootScope.$on('successfulSignIn', () => {

                this.isUserLoggedIn = true;
                this.refreshSavedPaymentDetails().then();

                if ($state.current.name === 'eStories.navbars.howItWorks') {
                    $location.path('/');
                }

                if ($state.current.name === 'eStories.navbars.freemium') {
                    $location.path('/');
                }

                if ($state.current.name === 'eStories.navbars.home') {
                    $location.path('/');
                }

                this.refreshSubscriptionDetails(() => {
                    $rootScope.$broadcast('refreshHomePageSections');
                    $rootScope.$broadcast('refreshCtas');
                    if (this.pendingPlanPurchaseType && !this.isMember()) {
                        if (GiftModel.giftToken != null) {
                            return;
                        }
                        switch (this.pendingPlanPurchaseType) {
                            case "BASIC_TRIAL":
                                this.showUpdatePaymentDetailsModal();
                                break;
                            case "PLAN":
                                if (this.chosenPlan) {
                                    this.showUpdatePaymentDetailsModal();
                                } else {
                                    this.showChoosePlanModal();
                                }
                                break;
                            case "PROMO":
                                // this.showUpdatePaymentDetailsModal();
                                break;
                        }
                    } else if (this.pendingAudiobookPurchase) {
                        this.showUpdatePaymentDetailsModal();
                    }
                });
            });

            this.resetAccountModel = () => {
                this.savedPaymentDetails = null;
                this.subscriptionDetails = null;
                this.userDetails = null;
            };

            this.freezeMembership = (days) => {
                var freezeMembershipObj = {subscriptionId: this.subscriptionDetails.subscription.id, days: days};
                return WS.callServer('subscription/freezeSubscription', freezeMembershipObj)
            };

            this.unfreezeMembership = () => {
                let req = {subscriptionId: this.subscriptionDetails.subscription.id};
                return WS.callServer('subscription/unfreezeSubscription', req);
            };

            this.clearPromoPackage = () => {
                PromoModel.clearPromoPackage();
            };

            $rootScope.$on('vipSignUp', () => {
                this.trialType = 'vipSignUp';
            });

            $rootScope.$on('2mo2cdtSignUp', () => {
                this.trialType = 'twoMo2cdt';
                if ($location.path().indexOf('groupon2mo2cdt') > -1) {
                    this.trialTypeSponsor = 'groupon';
                }
            });

            $rootScope.$on('successfulSignOut', () => {
                this.isUserLoggedIn = false;
                this.resetAccountModel();
                this.resetPlanPurchaseProperties();
                PromoModel.showBar = false;
                $rootScope.$broadcast('refreshHomePageSections');
                LL.tagEvent('Log Out');
                // PromoModel.halfOff3 is set when PromoModel.activateHalfOff is called
                PromoModel.activateHalfOff3MonthsSale();
                // PromoModel.clearPromoPackage();
                if ($rootScope.stateOnlyForLoggedInUser($rootScope.currentState) || $rootScope.stateForPromoPlans($rootScope.currentState)) {
                    $location.path('/');
                }
            });

            $rootScope.$on('promoDetailsLoaded', (event, response) => {
                this.setPendingPlanPurchaseType('PROMO');
                this.setChosenPromoPlan(response);

            });

            $rootScope.$on("NOTIFICATION_SUBSCRIPTION_UPDATED", () => {
                this.refreshSubscriptionDetails(() => {
                    safeApply($rootScope);
                });
            });

            $rootScope.$on("NOTIFICATION_USER_DETAILS_UPDATED", () => {
                this.refreshUserDetails(() => {
                    safeApply($rootScope);
                });
            });

            $rootScope.$on("NOTIFICATION_PAYMENT_DETAILS_UPDATED", () => {
                this.refreshSavedPaymentDetails(() => {
                    safeApply($rootScope);
                });
            });
        }
    ]);
